import { HiArrowLongRight } from "react-icons/hi2";

export const LongArrow = ({ width, height, ...props }) => (
  <HiArrowLongRight size={width || height || 17} {...props} />
);
